import { onBeforeMount } from 'vue'

import { usePageStore } from '../../stores/page'
import { useDeviceType } from './use-device-type'
import { queueAdEvent } from '../utils/queue-ad-event'

export function useInitializeAd () {
  const pageStore = usePageStore()
  const deviceType = useDeviceType()

  onBeforeMount(() => {
    queueAdEvent((moltenBundle) => {
      const device = deviceType.value
      if (!device || typeof window === 'undefined') {
        return
      }

      const pageMeta = pageStore.pageData.pageMeta
      const metaData = pageStore.pageData.metaData

      const siteType = device
      const adZone = metaData?.adaAutoNative ? '_noad' : (metaData?.adAAdZone || '_default')
      const indexPage = pageMeta.pageType === 'structureterm'
      const adKeywords = metaData?.adKeywords || []
      const adAAdKeywords = metaData?.adAAdKeywords || []
      const nudeContent = metaData.nudeContent || false
      const autonative = !!metaData?.adaAutoNative
      const trackingPixelIdContent = metaData?.adaTrackingPixelIdContent || null

      if (nudeContent) {
        adAAdKeywords.push('nude_content')
      }

      moltenBundle.getClient().setSiteType(siteType)
      moltenBundle.getClient().setZone(adZone)

      if (!autonative) {
        moltenBundle.getClient().setIsIndexPage(indexPage)
        moltenBundle.getClient().addTargetingParameter('keywords', adKeywords)
      }

      if (adAAdKeywords.length > 0) {
        moltenBundle.getClient().setKeywords(adAAdKeywords)
        moltenBundle.getClient().addTargetingParameter('keywords', adKeywords)
      }

      moltenBundle.getClient().setIsIndexPage(indexPage)

      moltenBundle.cmd.push(() => {
        moltenBundle.finalize()
      })

      if (trackingPixelIdContent) {
        moltenBundle.createTrackingPixel(trackingPixelIdContent)
      }
    })
  })
}
